import React, { useRef, useState, useEffect } from 'react';
import emailjs from '@emailjs/browser';
import Footer from './footer';
import validate from './validateInfo';
import FormSuccess from './form-success';


const Contact = ({ channelData, callback }) => {
  const form = useRef();
  const inputData = {
    subject: '',
    name: '',
    email: '',
    message: ''
  };
  const [values, setValues] = useState(inputData);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = e => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value
    });
    setIsSubmitting(false)
  };

  const submitForm = e => {
    e.preventDefault();
    if (!values.name || !values.email || !values.message || !values.subject) {
      setErrors(validate(values));
    } else {
      emailjs.sendForm('service_63t6t5i', 'template_6l6z2v3', form.current, 'Rg4TZKKmTwKoYyTDZ')
        .then((result) => {
          console.log(result.text);
        }, (error) => {
          console.log(error.text);
        });
      setIsSubmitting(true)
    }
  }

  useEffect(
    () => {
      console.log("hi")
    },
    [isSubmitting]
  );

  return (
    <>
      <div className='contact-me'>
        <h3>Feel Free to give Feedback</h3>
        <div className='form-container'>
          {!isSubmitting ? (
            <div className='form-content-left'>
              <form ref={form} onSubmit={submitForm} className='form' noValidate>
                <div className='form-inputs'>
                  <input
                    className='form-input'
                    type='subject'
                    name='subject'
                    placeholder='Subject'
                    value={values.subject}
                    onChange={handleChange}
                  />
                  <p>{errors.subject && <span>{errors.subject}</span>}</p>
                </div>
                <div className='form-inputs'>
                  <input
                    className='form-input'
                    type='text'
                    name='name'
                    placeholder='Name'
                    value={values.name}
                    onChange={handleChange}
                  />
                  <p>{errors.name && <span>{errors.name}</span>}</p>
                </div>
                <div className='form-inputs'>
                  <input
                    className='form-input'
                    type='email'
                    name='email'
                    placeholder='Email'
                    value={values.email}
                    onChange={handleChange}
                  />
                  <p>{errors.email && <span>{errors.email}</span>}</p>
                </div>
                <div className='form-inputs'>
                  <input
                    className='form-input'
                    type='message'
                    name='message'
                    placeholder='Message'
                    value={values.message}
                    onChange={handleChange}
                  />
                  <p>{errors.message && <span>{errors.message}</span>}</p>
                </div>
                <button className='form-input-btn' type='submit'>
                  Submit
                </button>
              </form>
            </div>
          ) : (
            <FormSuccess />
          )}    
          <div className='form-content-right'>
          <ul className="social-links">
            {
              channelData && channelData.socialLinks.length > 0 && channelData.socialLinks.map((item, index) => {
                return (
                  <li key={index}>
                    <a href={item.url} target="_blank">
                      <i className={item.className} />
                    </a>
                  </li>
                )
              })
            }
          </ul>
          </div>     
        </div>
      </div>
      <Footer channelData={channelData} />
    </>
  );
};

export default Contact;